module.exports = __webpack_public_path__ + "img/parter-work12.a0ccaff6.png";